import { useCallback } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import Icon from '../../Components/Icon';
import logo from '../../../Assets/images/brand/logo-votorantim.png';

const pages = [
  { path: 'seller', icon: 'user', title: 'Vendedores' },
  { path: 'delegation', icon: 'userCog', title: 'Delegações' },
  { path: 'negotiationStatus', icon: 'addressBook', title: 'Tipos de Propostas' },
  // { path: 'company', icon: 'building', title: 'Companhias' },
  { path: 'player', icon: 'building', title: 'Players' },
  // { path: 'reasonForLoss', icon: 'userMinus', title: 'Motivo de Perda' },
  // { path: 'trait', icon: 'blender', title: 'Traços' },
  { path: 'pump', icon: 'gasPump', title: 'Bombas' },
  { path: 'affiliate', icon: 'warehouse', title: 'Filiais' },
  { path: 'affiliateTrait', icon: 'warehouse', title: 'Traços nas Filiais' },
  { path: 'affiliatePump', icon: 'warehouse', title: 'Bombas nas Filiais' },
  { path: 'pricePerDistance', icon: 'warehouse', title: 'Preços por Distância' },
  // { path: 'relativity', icon: 'greaterThanEqual', title: 'Relatividades' },
  { path: 'approvalAuthority', icon: 'userTie', title: 'Cargos de usuários' },
  // { path: 'approvalScheme', icon: 'usersCog', title: 'Estrutura de Alçadas de Aprovações' },
  { path: 'approvalMargin', icon: 'userCheck', title: 'Margens de Aprovações' },
  { path: 'hierarchyTrait', icon: 'userCheck', title: 'Aprovações de Traços' },
  { path: 'hierarchyPump', icon: 'userCheck', title: 'Aprovações de Bombas' },
  { path: 'hierarchyPayment', icon: 'userCheck', title: 'Aprovações de Pagamentos' },
  { path: 'cadFckBrSl', icon: 'cogs', title: 'FCK Brita Slumps' },
  { path: 'consumption', icon: 'cogs', title: 'Consumos' },
  { path: 'ownConsumption', icon: 'cogs', title: 'Consumo Próprio' },
  { path: 'factor', icon: 'cogs', title: 'Fatores' },
  { path: 'parameter', icon: 'cogs', title: 'Parâmetros' },
  { path: 'regionalEfficiency', icon: 'cogs', title: 'Eficiências Regionais' },
  { path: 'workOvertime', icon: 'userClock', title: 'Horas Extras' },
  { path: 'payment', icon: 'moneyBill', title: 'Pagamentos' },
  // { path: 'proposal', icon: 'file', title: 'Propostas' },
  { path: 'recommendation', icon: 'comments', title: 'Recomendações' },
  { path: 'spectra', icon: 'cogs', title: 'Spectras' },
  // { path: 'pricesRule', icon: 'tag', title: 'Preços Regra' },
  // { path: 'pricesContract', icon: 'tags', title: 'Preços Contrato' },
  // { path: 'pricesService', icon: 'tags', title: 'Preços Serviço' },
  // { path: 'manual', icon: 'book', title: 'Manuais' },
  // { path: 'updateNegotiationStatus', icon: 'wrench', title: 'Atualizar Status de Negociação' },
];

export default function Sidebar() {
  const { pathname } = useLocation();

  const isPageActive = useCallback((path) => pathname.includes(`/${path}`), [pathname]);

  return (
    <nav className="sidebar">
      <NavLink to="/refactor/backoffice" className="d-block pb-4">
        <img src={logo} alt="Votorantim" />
      </NavLink>
      <ul className="mt-8">
        {pages.map((page) => (
          <li key={page.path} className={isPageActive(page.path) ? 'active' : ''}>
            <NavLink to={`${page.path}`}>
              <Icon name={page.icon} className="mr-2 text-primary" />
              {page.title}
            </NavLink>
          </li>
        ))}
      </ul>
    </nav>
  );
}
